import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RecipePart} from "../../../dtos/recipePart";
import {Ingredient} from "../../../dtos/ingredient";

@Component({
  selector: 'app-recipe-part',
  templateUrl: './recipe-part-edit.component.html',
  styleUrls: ['./recipe-part-edit.component.css']
})
export class RecipePartEditComponent implements OnInit {

  recipePart : RecipePart;
  @Input() hideName : boolean = false;
  @Output() deleteEvent = new EventEmitter<boolean>();
  @Output() partChange = new EventEmitter<RecipePart>();

  ingredientInput : string = '';

  constructor() { }

  ngOnInit() {
  }

  @Input()
  get part() {
    return this.recipePart;
  }

  set part(val) {
    this.recipePart = val;
    this.partChange.emit(this.recipePart);
  }

  onStepChange(event, index) {
    if (index == this.recipePart.steps.length - 1) { // this is the last step
      if (event.length != 0) {
        this.recipePart.steps.push(null);
      }
    } else if (this.recipePart.steps.length > 2 && this.recipePart.steps.length - 2 == index) { // second to last step
      const val = this.recipePart.steps[this.recipePart.steps.length - 1];
      if (event.length == 0 && (val == null || val.length == 0)) { // last & second to last step are empty
        this.recipePart.steps.splice(this.recipePart.steps.length - 1);
      }
    }
  }

  parseIngredient(ingredient: string) {
    this.recipePart.ingredients.push(Ingredient.parseIngredient(ingredient));
    this.ingredientInput = '';
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  onDelete() {
    this.deleteEvent.emit(true);
  }

}
